<template>
  <container>
    <div class="search-page page w-100 p-0 m-0">
      <banner></banner>
      <job-search-list class="search-page__list container"></job-search-list>
    </div>
  </container>
</template>
<script>
/**
 * ==================================================================================
 * Search tools page
 * ==================================================================================
 **/

import MainLayout from '@/layouts/MainLayout'
import Banner from '@/components/Banner'
import JobSearchList from '@/components/lists/JobSearchList'

export default {
  metaInfo: function() {
    const title = 'Tools'
    return {
      title: title,
      meta: [
        {
          property: 'og:title',
          content: title
        }
      ]
    }
  },
  components: {
    container: MainLayout,
    Banner,
    JobSearchList
  }
}
</script>
<style lang="scss" scoped>
.search-page {
  margin-top: -84px !important; // Header height

  &__list {
    margin: 50px auto 100px auto;
  }
}
</style>
